import { useMutation } from '@tanstack/react-query';
import { getReqUrl, handleDataPlatformError } from '../utils';
import { DROPS_ENDPOINT } from './constants';
import dataPlatformFetch from '../../../utils/dataPlatformFetch';

export const useMakePurchase = () => {
  return useMutation(async (variables) => {
    const url = getReqUrl(
      DROPS_ENDPOINT,
      `/reservation/${variables.reservationId}/purchase`
    );
    const res = await dataPlatformFetch(url, {
      method: 'POST',
      recaptchaToken: variables.recaptchaToken,
      correlationId: variables.correlationId,
      body: variables.updateData ? JSON.stringify(variables.updateData) : null
    });

    if (!res.ok) {
      await handleDataPlatformError(res);
    }

    return res.json();
  });
};
